import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { withRouter } from 'next/router';

import FlexBox from '../FlexBox';
import OrderForm from './OrderForm';

const OrderFormWrapper = styled(FlexBox)`
  background: none;
  flex: 1;
  flex-direction: column;
  margin: 15px 0;
  padding: 0 26px;
  min-height:${({ pro }) => pro ? '' : '260px'};

  &:first-child {
    border-right: 1px solid ${({ theme }) => theme.inputBorder};
  }
`;

const mapStateToProps = ({ tickers }, { pair }) => {
  const symbol = (pair || []).join('');
  const { tickSize, minTrade } = tickers[symbol] || {};
  return { tickSize, minTrade, symbol };
};

export default
@withRouter
@connect(mapStateToProps)
class InnerOrderForms extends Component {
  static propTypes = {
    symbol: PropTypes.string,
    base: PropTypes.string.isRequired,
    pair: PropTypes.array.isRequired,
    orderType: PropTypes.string.isRequired,
    router: PropTypes.object,
    tickSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minTrade: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }

  static defaultProps = {
    symbol: '',
    tickSize: '0.01',
    minTrade: '0.01',
  };

  render() {
    const { router: { pathname } } = this.props;
    const pro = pathname === '/trade-pro';
    return (
      <Fragment>
        <OrderFormWrapper pro={pro}>
          <OrderForm side="BUY" {...this.props} pro={pro} />
        </OrderFormWrapper>
        <OrderFormWrapper pro={pro}>
          <OrderForm side="SELL" {...this.props} pro={pro} />
        </OrderFormWrapper>
      </Fragment>
    );
  }
}
